import { render } from "./SearchView.vue?vue&type=template&id=36f5412b&scoped=true&ts=true"
import script from "./SearchView.vue?vue&type=script&lang=ts"
export * from "./SearchView.vue?vue&type=script&lang=ts"

import "./SearchView.vue?vue&type=style&index=0&id=36f5412b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f5412b"]])

export default __exports__